<template>
  <div class="saas-newsletter-signup-card">
    <ButtonIcon type="secondary" icon="iconoir-megaphone"></ButtonIcon>
    <strong class="saas-newsletter-signup-card__title">Stay up to date</strong>
    <p class="saas-newsletter-signup-card__text">
      Get valuable resources, invites to events, and behind-the-scenes insight
      into what we’re doing.
    </p>

    <NewsletterSignup
      class="saas-newsletter-signup-card__form"
      direction="vertical"
    />
  </div>
</template>
<script>
import NewsletterSignup from '@saas/components/NewsletterSignup'
export default {
  name: 'NewsletterSignupCard',
  components: {
    NewsletterSignup,
  },
}
</script>
